import { atom } from 'recoil';
import { platinumTabs } from '../components/game/PlatinumShop/PlatinumShopContainer';

export const platinumTabAtom = atom({
	key: 'platinumTabAtom',
	default: 'Buffs' as (typeof platinumTabs)[number],
});
